module.exports = __webpack_public_path__ + "img/construction-bg.b1ce2845.jpg";